export enum FilterActions {
	SET_GENRES = 'FILTER_SET_GENRES',
	SET_VALUE = 'FILTER_SET_VALUE'
}
